'use client';

import config from '@packages/config';
import type { JSX } from 'react';
import type { CmsData } from '../../../interfaces/webapp_json';
import { CmsGeneralAccordion } from '../../components/CmsAccordion/CmsAccordion.client';
import { ComponentRecognizer } from '../../components/ComponentRecognizer/ComponentRecognizer.client';
import type { FooterBlockType } from '../../components/Footer/types';
import { useContentFilters } from '../../hooks/useContentFilters';

type FooterAccordionProps = {
  data: CmsData;
};

export const FooterAccordion = ({ data }: FooterAccordionProps): JSX.Element => {
  const filters = useContentFilters();
  const comp = (data.paragraph as FooterBlockType[])
    ?.filter(
      (item) =>
        item?.parent_field_name === 'field_footer' && filters.every((filter) => filter(item)),
    )
    ?.map((item) => ({
      id: `footer-accordion-${item.id}`,
      headline: item.field_headline,
      isOpen: item.field_is_open,
      content: <ComponentRecognizer item={item} />,
    }));

  return (
    <div className="[&>div]:bg-color-footer-main! [&_button_svg]:text-size-headline-3xl! [&_button_svg]:text-color-footer-contrasttext [&_button]:text-color-footer-contrasttext! m-0 w-full p-0 [&.footer_block_badges]:flex [&.footer_block_badges]:gap-[0.8rem] [&.layout-variant-inline]:flex [&.layout-variant-inline]:w-auto [&.layout-variant-inline]:shrink-0 [&.layout-variant-inline]:content-center [&.layout-variant-inline]:align-top">
      <CmsGeneralAccordion
        styleVariant={config.styleVariant}
        entries={comp}
        highlightOpen={false}
      />
    </div>
  );
};
